import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { RightArrowIcon } from 'styles/assets/icons';

import styles from '../universal-search.module.scss';
import { getMixpanelPageName } from './helpers';
import { ViewAllBtnProps } from './interface';

const ViewAllBtn = (props: ViewAllBtnProps) => {
  const { optionsData, searchTerm, clearSearch } = props;

  const { t } = useTranslation(['trading']);

  const trackOptionView = () => {
    trackMixpanelEvent('Search - Option view all clicked', {
      source: getMixpanelPageName(),
      search_term: searchTerm,
    });
  };

  const onClick = () => {
    trackOptionView();
    clearSearch();
  };

  const { underlying_asset: underlyingAsset, symbol } = optionsData[0] || {};

  return (
    <Link
      data-testid="universal-search-view-all-btn"
      to={`${routes.options_chain.trade}/${underlyingAsset?.symbol}/${symbol}`}
      className={styles['view-all']}
      onClick={onClick}
    >
      {t('trading:viewAll')}
      <RightArrowIcon />
    </Link>
  );
};

export default ViewAllBtn;
